
import MaintenanceShow from '../components/maintenances/MaintenanceShow.vue';
import Vue from 'vue';

Vue.component('maintenance-show', MaintenanceShow);

export default Vue.extend({});
